var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { FunctionColor, Spacer } from '@lux/tokens';
import styled, { css } from 'styled-components';
export var CategoryIcon = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", "\n\n    svg path {\n        fill: ", ";\n        width: 12px;\n        height: 12px;\n    }\n"], ["\n    ", "\n\n    svg path {\n        fill: ", ";\n        width: 12px;\n        height: 12px;\n    }\n"])), function (props) {
    return props.withRightMargin && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n            margin-right: ", ";\n        "], ["\n            margin-right: ", ";\n        "])), Spacer.S);
}, FunctionColor.function100);
var templateObject_1, templateObject_2;
